export function formatDate(d) {
  var date = new Date(d)
  return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
}

export function parsePath(path) {
  let arr = path.split('/')
  if (arr.length === 2) {
    return { category: arr[1], slug: '' }
  } else {
    return { category: arr[1], slug: arr[2] }
  }
}



// WEBPACK FOOTER //
// ./src/front/helper.js